import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import no from 'vuetify/es5/locale/no'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: '#69ADB1',
        secondary: '#FB6863',
        accent: '#82B1FF',
        error: '#dc3545',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107'
      }
    }
  },
  lang: {
    locales: {no},
    current: 'no'
  },
  icons: {
    iconfont: 'mdi'
  }
})
